import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.RIGHT_PARAM_SET_LIST),
    addRightParamSet: payload => axios.post(HTTP.RIGHT_PARAM_SET, { ...payload }),
    updateRightParamSet: payload => axios.put(HTTP.RIGHT_PARAM_SET, payload),
    deleteRightParamSet: payload => axios.delete(HTTP.RIGHT_PARAM_SET, { params: { id: payload } })
}
